/**
 * Login is one primary button — there is no second way in for a new app (§3.7).
 * This app issues no credentials of its own, so there is nothing else to offer.
 */

import { HUB_URL } from "./config";

export function login(): void {
  window.location.href = `${HUB_URL}/auth/slack?redirect=${encodeURIComponent(window.location.origin)}`;
}

/**
 * Signs out through the Worker, then returns to the Hub.
 *
 * The session cookies are HttpOnly, so this page cannot delete them: the old
 * `document.cookie = ...; Max-Age=0` was a no-op, and the Hub put the person
 * straight back in. `POST /api/auth/logout` ends the Hub session and clears
 * both cookies. The Hub is reached even if that call fails, so the button
 * never leaves someone stuck on the page.
 */
export async function logout(): Promise<void> {
  try {
    const res = await fetch("/api/auth/logout", { method: "POST", credentials: "same-origin" });
    if (!res.ok) console.warn(`[auth] logout answered ${res.status}`);
  } catch (e) {
    console.warn("[auth] logout request failed", e);
  }
  window.location.href = HUB_URL;
}
